exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shortcut-item[data-v-7a242f18]:hover{background-color:#ffefc1}.shortcut-item-sepline[data-v-7a242f18]{border-bottom:1px dashed #d7d4f0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a242f18","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/query/QueryDate2Field.vue
// module id = 1671
// module chunks = 1